import { ResultPagDTO } from "@/interfaces/base-dto";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";
import { RegistroVisitaFiltroDTO, RegistroVisitaParmDTO } from "@/interfaces/crm-visit";

export function getCrmVisitInstitution(id): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_REGISTRATION_INSTITUTIONS.replace('{id}', id))).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}


export function saveCrmVisit(parm: RegistroVisitaParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CRM_VISIT_REGISTRATION, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateCrmVisit(parm: RegistroVisitaParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_VISIT_REGISTRATION, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisit(filters: RegistroVisitaFiltroDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_REGISTRATION, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getCrmVisitDetails(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_VISIT_REGISTRATION}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getCrmVisitPlanningDetails(idPlanning: Number): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_REGISTRATION_PLANNING.replace('{id}', idPlanning.toString()))).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function deleteCrmVisit(id: Number): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.CRM_VISIT_REGISTRATION}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisitPlanning(idInstitution: number): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_REGISTRATION_PLANNING_INSTITUTION.replace('{id}', idInstitution.toString()))).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisitVisitors(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_REGISTRATION_VISITORS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisitContacts(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_REGISTRATION_CONTACTS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}
